/**
 * Keep the duplicated flat-board header and the real group header on one
 * geometry contract. Table column headers use the same 36px block height.
 */
export const KANBAN_GROUP_HEADER_HEIGHT = 36;

const KANBAN_ROW_SORT_ID_PREFIX = 'kanban-row-group:';

export const kanbanRowSortId = (rowKey: string): string =>
  `${KANBAN_ROW_SORT_ID_PREFIX}${rowKey}`;

export const kanbanRowKeyFromSortId = (sortId: string): string | undefined =>
  sortId.startsWith(KANBAN_ROW_SORT_ID_PREFIX)
    ? sortId.slice(KANBAN_ROW_SORT_ID_PREFIX.length)
    : undefined;
